import { createAction, props } from '@ngrx/store';

import { Owner } from '../../../objects/owner';
import { ServiceArea } from '../../../objects/service-area';
import { Storefront } from '../storefront.service';
import { DestinationSelectSetting } from '../../../objects/destination-select-setting';

/**
 * Owner
 */
export const loadOwner = createAction(
  '[Owner] Load Owner',
);

export const loadOwnerSuccess = createAction(
  '[Owner] Load Owner Success',
  props<{owner: Owner}>(),
);

export const loadOwnerFailure = createAction(
  '[Owner] Load Owner Failure',
  props<{error: Error}>(),
);

/**
 * Service areas
 */
export const loadServiceAreas = createAction(
  '[Owner] Load Service Areas',
);

export const loadServiceAreasSuccess = createAction(
  '[Owner] Load Service Areas Success',
  props<{serviceAreas: ServiceArea[]}>(),
);

export const loadServiceAreasFailure = createAction(
  '[Owner] Load Service Areas Failure',
  props<{error: Error}>(),
);


/**
 * Storefronts
 */
export const loadStorefronts = createAction(
  '[Owner] Load Storefronts',
);

export const loadStorefrontSuccess = createAction(
  '[Owner] Load Storefronts Success',
  props<{storefront: Storefront}>(),
);

export const loadStorefrontFailure = createAction(
  '[Owner] Load Storefronts Failure',
  props<{error: Error}>(),
);

/**
 * Destination Select Setting
 */

export const setDestinationSelectSetting = createAction(
  '[Owner] Set Destination Select Setting',
  props<{destinationSelectSetting: DestinationSelectSetting}>(),
);
